import React from "react";

import { Header } from "./Header";

import * as styles from "./styles";

export function PopupContent({
  title,
  secondaryTitleStyle,
  children,
  onClose,
}: {
  title: string;
  secondaryTitleStyle?: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
}) {
  return (
    <div className={styles.container}>
      <Header title={title} secondary={secondaryTitleStyle} onClose={onClose} />
      {children}
    </div>
  );
}
